angular.module('impactx.deliveryadvice').controller('DeliveryAdviceSupplierListCtrl', [
    'selectedListItems',
    DeliveryAdviceSupplierListCtrl
]);

function DeliveryAdviceSupplierListCtrl(selectedListItems) {
    var buttonDefinition = [
        {
            label: "details",
            linkFunction: getDetailLink,
            type: 'link',
            condition: selectedListItems.isSingleSelection,
            process: 'ViewDeliveryAdviceSupplier'
        }
    ];

    this.meta = {
        buttonDefinition: buttonDefinition,
        rowTemplate: 'modules/deliveryadvice/templates/deliveryadvicesupplierlist.row.tmpl.html',
        isSelectAble: true,
        ctrl: this,
        endpoint: '/deliveryadvice/listsupplier',
        id: "deliveryadvicesupplierlist",
        excelExport: true
    };

    this.getMeta = function () {
        return this.meta;
    };

    function getDetailLink() {
        return "deliveryadvicesupplier/" + selectedListItems.getFirstSelectedItem().pohId + "/" + selectedListItems.getFirstSelectedId();
    }
}